import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { ConsorsConsolidationsTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
    position?: number;
    subscriptionIdentifier: string;
};

export const schemaLoanRequestResolver_GetConsorsConsolidationData = ConsorsConsolidationsTableDefinitionZod.pick({
    contractIdentifier: true,
    failureReason: true,
    status: true,
    timestamp: true,
    url: true,
}).nullable();

export type SchemaLoanRequestResolver_GetConsorsConsolidationData = z.infer<
    typeof schemaLoanRequestResolver_GetConsorsConsolidationData
>;

export type LoanRequestResolver_GetConsorsConsolidationData = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetConsorsConsolidationData
>;
